<template>
    <v-card
        class="mx-auto overflow-hidden"
        min-height="400"
    >
        <v-app-bar
            color="deep-purple accent-4"
            dark
            prominent
        >
            <v-toolbar-title>Giderler</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn v-if="false" icon>
                <v-icon>mdi-magnify</v-icon>
            </v-btn>

            <v-btn v-if="false" icon>
                <v-icon>mdi-filter</v-icon>
            </v-btn>

            <v-btn v-if="false" icon>
                <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>

            <v-btn
                color="pink"
                fab
                dark
                small
                @click="dialog = true"
            >
                <v-icon>mdi-plus</v-icon>
            </v-btn>
        </v-app-bar>

        <v-card-text>
            Harcama giderlerini buradan ekleyebilir, ve goruntuleyebilirsiniz
        </v-card-text>

        <v-overlay absolute :value="loading">
            <v-progress-circular indeterminate size="64"/>
        </v-overlay>

        <v-data-table
            :headers="headers"
            :items="items"
            item-key="islem_zamani"
            :disable-pagination="true"
            hide-default-footer
        >
            <template v-slot:item.gider="{ item }">
                <v-chip
                    :color="item.color"
                    dark
                >
                    <v-icon left>
                        {{ item.icon }}
                    </v-icon>
                    {{ item.gider }}
                </v-chip>
            </template>
            <template v-slot:item.tutar="{ item }">
                <v-chip
                    color="orange accent-2"
                    dark
                >
                    ₺ {{ item.tutar }}
                </v-chip>
            </template>
        </v-data-table>

        <v-dialog
            v-model="dialog"
            persistent
            max-width="600px"
        >
            <v-card>
                <v-card-title>
                    <span class="headline">Harcama Ekle</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-row>
                                <v-col
                                    cols="12"
                                    sm="12"
                                >
                                    <v-select
                                        v-model="form.gider"
                                        :items="['Yakıt', 'Park']"
                                        :rules="rules.gider"
                                        required
                                        label="Harcama Seciniz"/>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="12"
                                >
                                    <v-text-field
                                        v-model="form.tutar"
                                        :rules="rules.tutar"
                                        required
                                        label="Harcama Tutarı"
                                        type="number"
                                        prefix="₺"/>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="blue darken-1"
                        text
                        @click="dialog = false"
                    >
                        Vazgeç
                    </v-btn>
                    <v-btn
                        color="blue darken-1"
                        text
                        :disabled="creating"
                        @click="save"
                    >
                        Kaydet
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
    export default {
        name: 'gider-yonetimi',
        data() {
            return {
                dialog: false,
                valid: false,
                loading: false,
                creating: false,
                items: [],
                form: {
                    gider: 'Yakıt',
                    tutar: null,
                },
                rules: {
                    gider: [
                        v => !!v || 'Gider giriniz',
                    ],
                    tutar: [
                        v => !!v || 'Tutar giriniz',
                    ],
                },
                headers: [
                    {
                        text: 'Harcama',
                        align: 'start',
                        value: 'gider',
                    },
                    { text: 'Zamanı', value: 'islem_zamani' },
                    { text: 'Tutar', value: 'tutar' },
                ],
            };
        },
        methods: {
            fetch() {
                this.loading = true;
                this.$requests.Gider.getGider()
                    .then((data) => {
                        this.items = (data || []).map((d) => {

                            d.color = 'deep-purple';
                            d.icon = 'mdi-oil';
                            if (d.gider === 'Park') {
                                d.color = 'lime darken-2';
                                d.icon = 'mdi-parking';
                            }

                            return d;
                        });
                    })
                    .catch((e) => {
                        console.error('failed to fetch getgider', e);
                    })
                    .then(() => {
                        this.loading = false;
                    })
            },
            save() {
                this.$refs.form.validate();
                this.$nextTick(() => {
                    if (this.valid) {
                        this.create();
                    }
                });
            },
            create() {
                this.creating = true;
                this.$requests.Gider.createGider(this.form)
                    .then(() => {
                        this.reset();
                        this.fetch();
                    })
                    .catch((e) => {
                        console.error('error on createGider', e);
                    })
                    .then(() => {
                        this.creating = false;
                    });
            },
            reset() {
                this.dialog = false;
                this.$refs.form.reset();
                this.$refs.form.resetValidation();
            }
        },
        mounted() {
            this.fetch();
        },
    };
</script>
